<template>
    <div class="home" >
        <div class="container p-l-r-0 container-shadow">
            <div class="row">
                <UserProfile></UserProfile>
            </div>
            <div class="row content-holder">
                <div class="col-sm-3 col-md-3 col-xs-3 dashboard-sec-left" >
                    <LeftNav :type="'documents'"/>
                </div>
                <div class="col-sm-9 col-md-9 col-xs-9 dashboard-sec-right" >
                    <h3 class="text-left sub-head">Documents</h3>
                    <table class="table table-hover roa-table">
                        <thead>
                            <tr>
                                
                                <th>
                                   Name
                                </th>
                                <th>
                                   Download
                                </th>
                                
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Details of Other Companies</td>
                                <td><a href="javascript://" @click="downloadFile('Details-of-Other-Companies.docx')"><img src="../../assets/icon-download.png"></a></td>
                            </tr> 
                            <tr>
                                <td>DIR 2 Consent to act as a Director</td>
                                <td><a href="javascript://" @click="downloadFile('DIR-2-Consent-to-act-as-a-Director.docx')"><img src="../../assets/icon-download.png"></a></td>
                            </tr> 
                            <tr>
                                <td>Form 9</td>
                                <td><a href="javascript://" @click="downloadFile('Form-9.docx')"><img src="../../assets/icon-download.png"></a></td>
                            </tr> 
                            <tr>
                                <td>Info  Annexure 1</td>
                                <td><a href="javascript://" @click="downloadFile('Info-Annexure-1.docx')"><img src="../../assets/icon-download.png"></a></td>
                            </tr> 
                            <tr>
                                <td>info Annexure 1 LLP</td>
                                <td><a href="javascript://" @click="downloadFile('info-Annexure-1-LLP.docx')"><img src="../../assets/icon-download.png"></a></td>
                            </tr>  
                            <tr>
                                <td>NOC</td>
                                <td><a href="javascript://" @click="downloadFile('NOC.docx')"><img src="../../assets/icon-download.png"></a></td>
                            </tr> 
                            <tr>
                                <td>Specimen Signature 07042019</td>
                                <td><a href="javascript://" @click="downloadFile('Specimen-Signature-07042019.docx')"><img src="../../assets/icon-download.png"></a></td>
                            </tr> 
                            <tr>
                                <td>subscribers and consent sheet</td>
                                <td><a href="javascript://" @click="downloadFile('subscribers-and-consent-sheet.doc')"><img src="../../assets/icon-download.png"></a></td>
                            </tr> 
                           
                        </tbody>
                       
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import LeftNav from "../layouts/leftNav.vue"
import documents from '../../services/documents'
import UserProfile from "../layouts/profile-header.vue"
export default {
    name:'billing-index',
    data(){
        return {
            list:{},
            list_present:false,
            file_path:process.env.VUE_APP_URL,
        }
    },
     components: {
        LeftNav,
        UserProfile
    },
    methods: {
       downloadFile(fname) {
              documents.download({doc:fname}).then((response) => {
                  var filelink =response.data.files;
                    const link = document.createElement("a");
                    link.href = filelink;
                    link.setAttribute("download", filelink); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                    link.remove()
                });
          }
    },
    mounted(){
       
    }
};
</script>